var Isotope = require('isotope-layout/dist/isotope.pkgd.min');

window.AblCh = window.AblCh || {};


$(function () {
  if ($('#abl-proposals').length > 0) {
    var $body = $('body');

    // On proposals page, set redirectAfterLoginUri globally to the current page
    var redirectAfterLoginUri = $('#abl-proposals').data('redirect-after-login-uri');
    $('#login-form').find('[name="redirectAfterLoginUri"]').val(redirectAfterLoginUri);

    $body.on('click', '[data-js-binding="show-login"]', function (e) {
      e.preventDefault();
      $('#toggleLogin').click();
    })

    $body.on('click', '[data-js-binding="upvote-trigger"]', function (e) {
      AblCh.castVote(e.target, 1);
    })

    $body.on('click', '[data-js-binding="downvote-trigger"]', function (e) {
      AblCh.castVote(e.target, -1);
    })

    AblCh.initIsotopeTiles();
  }
})

AblCh = $.extend(AblCh, {

  // isotope does not work the jQuery way in conjunction with (current) webpack
  // use plain vanilla javascript instead
  // https://stackoverflow.com/questions/31077156/isotope-js-and-webpack-possible
  initIsotopeTiles: function () {

    if ($('.isotope-grid').length > 0) {

      // todo: handle clicks in modal

      // append modal to body, otherwise it will be hidden by the backdrop div!
      $('#proposalModal').appendTo('body');

      // only acitve/working on GV layout. https://redmine.visol.ch/issues/26240
      this.loadVotes();

      // Display vote buttons
      $('.vote-buttons').toggleClass('d-none', 'd-block');

      $('#proposalModal').on('show.bs.modal', function (event) {
        var $closestProposalItem = $(event.relatedTarget).closest('.proposal_item');
        var text = $closestProposalItem.data('fulltext');
        var author = $closestProposalItem.data('author');
        var date = $closestProposalItem.data('date');
        var category = $closestProposalItem.data('category');
        var proposalTitle = $closestProposalItem.data('title');
        var answer = $closestProposalItem.data('answer');
        var answerAuthor = $closestProposalItem.data('answerAuthor');

        var modal = $(this);
        modal.find('.modal-title').html(proposalTitle);
        modal.find('.bodytext').html(text);
        modal.find('.author').html(author);
        modal.find('.date').html(date);
        modal.find('.category').html(category);
        modal.find('.answer').html(answer);
        modal.find('.answerAuthor').html(answerAuthor);

        if (answer == undefined) {
          modal.find('.answer-area').hide();
        } else {
          modal.find('.answer-area').show();
        }
      });

      // init isotope in plain javascript.
      // $('.isotope-grid').isotope() is not working with webpack
      var iso = new Isotope('.isotope-grid', {
        itemSelector: '.proposal_item',
        layoutMode: 'masonry',
      });

      $('.filter-button-group').on('click', 'button', function (e) {
        e.preventDefault();
        const filterValue = $(this).data('filter');
        // iso.filter() throws error
        // https://stackoverflow.com/q/58492065/2116703
        iso.arrange({filter: filterValue});
      });

    }

  },

  castVote: function (trigger, decision) {
    var $proposal = $(trigger).closest('[data-node-identifier]');

    $('button', $proposal).prop('disabled', true);

    var subjectIdentifier = $proposal.data('node-identifier');
    var subjectIdentifierHmac = $proposal.data('node-identifier-hmac');

    var data = {
      "subjectIdentifier": subjectIdentifier,
      "subjectIdentifierHmac": subjectIdentifierHmac,
      "decision": decision
    };

    fetch('/_api/v1/vote', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then(response => response.json())
      .then(data => {
        this.loadVotes();
      })
      .catch((error) => {
        this.loadVotes();
      });

  },

  loadVotes: function () {
    // load votes
    $.getJSON('/_api/v1/votes', function (votes) {
      $.each(votes.data, function (key, item) {
        var nodeId = '[data-node-identifier="' + item.nodeIdentifier + '"]';
        var canVote = item.canVote;

        // Needs both data and attr, see https://stackoverflow.com/a/51480899/1517316
        $(nodeId + ' [data-can-vote]').data('can-vote', canVote);
        $(nodeId + ' [data-can-vote]').attr('data-can-vote', canVote);

        if (!canVote) {
          $(nodeId + ' .voting-notice').removeClass('d-none');
          $(nodeId + ' button').prop('disabled', true);
        }

        $(nodeId + ' [data-js-binding="upvote-count"]').text(item.upvoteCount);
        $(nodeId + ' [data-js-binding="downvote-count"]').text(item.downvoteCount);
      });
    });

  }

})
